import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  sparxsEditorSaveSucceededForFiles,
  sparxsEditorSaveFailed,
} from "@/features/sparxsEditor/store/domainActions";
import type { RootState } from "@/store/app/storeTypes";

export interface SparxsSaveToastFeedback {
  saveFeedbackId: string;
  ok: boolean;
  error?: string;
}

export interface SparxsEventHandlerState {
  updatePreview: boolean;

  blueprintReloadNonce: number;

  sparxSaveEpoch: number;

  lastSparxSaveToastFeedback: SparxsSaveToastFeedback | null;
}

const initialState: SparxsEventHandlerState = {
  updatePreview: false,
  blueprintReloadNonce: 0,
  sparxSaveEpoch: 0,
  lastSparxSaveToastFeedback: null,
};

const SparxsEventHandlerSlice = createSlice({
  name: "sparxsEventHandler",
  initialState,
  reducers: {
    toUpdatePreview: (state, action: PayloadAction<boolean>) => {
      state.updatePreview = action.payload;
      if (action.payload === true) {
        state.blueprintReloadNonce += 1;
      }
    },
    clearLastSparxSaveToastFeedback: (state) => {
      state.lastSparxSaveToastFeedback = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sparxsEditorSaveSucceededForFiles, (state, action) => {
        state.updatePreview = true;
        state.blueprintReloadNonce += 1;
        state.sparxSaveEpoch += 1;
        const { saveFeedbackId } = action.payload;
        if (saveFeedbackId != null && saveFeedbackId !== "") {
          state.lastSparxSaveToastFeedback = {
            saveFeedbackId,
            ok: true,
          };
        }
      })
      .addCase(sparxsEditorSaveFailed, (state, action) => {
        const { saveFeedbackId, error } = action.payload;
        if (saveFeedbackId != null && saveFeedbackId !== "") {
          state.lastSparxSaveToastFeedback = {
            saveFeedbackId,
            ok: false,
            error,
          };
        }
      });
  },
});

export const { clearLastSparxSaveToastFeedback, toUpdatePreview } =
  SparxsEventHandlerSlice.actions;

export const selectLastSparxSaveToastFeedback = (state: RootState) =>
  state.editor.sparxsEventHandler.lastSparxSaveToastFeedback;

export const selectSparxSaveEpoch = (state: RootState) =>
  state.editor.sparxsEventHandler.sparxSaveEpoch;

export default SparxsEventHandlerSlice.reducer;
